module.exports = {"id":"dp3_4l3q4","text":"Computational Thinking and Programming","instructions":"Why do different programming languages exist?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.4","questionType":"PickOne","random":true,"options":[{"id":"dp3_4l3q4-a1","text":"They are designed for different tasks and contexts","score":3.7},{"id":"dp3_4l3q4-a2","text":"They perform the same functions in all cases","score":1.3},{"id":"dp3_4l3q4-a3","text":"They are created only to replace older languages","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.4/l3q4.json
// module id = 1183
// module chunks = 41